var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMoreIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "7px",
    viewBox: "0 0 27 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#BFD62F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,3.5 C27,5.432644 25.432644,7 23.5,7 C21.567356,7 20,5.432644 20,3.5 C20,1.567356 21.567356,0 23.5,0 C25.432644,0 27,1.567356 27,3.5",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3.5 C17,5.432644 15.432644,7 13.5,7 C11.567356,7 10,5.432644 10,3.5 C10,1.567356 11.567356,0 13.5,0 C15.432644,0 17,1.567356 17,3.5",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,3.5 C7,5.432644 5.432644,7 3.5,7 C1.567356,7 0,5.432644 0,3.5 C0,1.567356 1.567356,0 3.5,0 C5.432644,0 7,1.567356 7,3.5",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMoreIconActive);
export default __webpack_public_path__ + "static/media/new-more-icon-active.55939d4822e803b83150d8d6a43d856a.svg";
export { ForwardRef as ReactComponent };